const API_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";

export const STAFF_CHECK_IN_HISTORY_PAGE_SIZE = 25;

export const STAFF_CHECK_IN_HISTORY_ORDER_BY = [
    { column: "CREATED_AT", order: "DESC" },
    { column: "ID", order: "DESC" },
];

export const buildStaffCheckInHistoryVariables = ({ eeID, period, page = 1 } = {}) => {
    const eventID = String(eeID ?? "").trim();
    const where = eventID ? { column: "EE_ID", operator: "EQ", value: eventID } : undefined;

    if (where && period?.[ 0 ]?.isValid?.() && period?.[ 1 ]?.isValid?.())
    {
        where.AND = [
            {
                column: "CREATED_AT",
                operator: "GTE",
                value: period[ 0 ].clone().startOf("day").format(API_DATE_TIME_FORMAT),
            },
            {
                column: "CREATED_AT",
                operator: "LTE",
                value: period[ 1 ].clone().endOf("day").format(API_DATE_TIME_FORMAT),
            },
        ];
    }

    return {
        where,
        orderBy: STAFF_CHECK_IN_HISTORY_ORDER_BY,
        first: STAFF_CHECK_IN_HISTORY_PAGE_SIZE,
        page: Number.isInteger(page) && page > 0 ? page : 1,
    };
};
